import { Injectable } from '@angular/core';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocaleTokenSearch, LocaleTokenValue } from '../models/locale-token';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LocaleTokenValueEntityService extends BaseEntityService<LocaleTokenValue> {

  localeTokenValues$: BehaviorSubject<LocaleTokenValue[]> = new BehaviorSubject([]);

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'localeTokenValue', plural: 'localeTokenValues', url: 'locale-token-values' },
      routerParamsService
    );
    this.nameId = 'localeTokenValueId';
  }

  getWithQuery(queryParams?: {
    localeTokenIds?: string,
    featureFlagIds?: string,
    locale?: LocaleTokenValue['locale'],
    offset?: number,
    limit?: number
  }, disableDefaultWrap: boolean = false): Observable<LocaleTokenValue[]> {
    return super.getWithQuery(queryParams, disableDefaultWrap);
  }

  localeTokenSearch(params: LocaleTokenSearch): Observable<LocaleTokenValue[]> {
    return this.httpClient
      .post([environment.apiUrl, 'locale-token-searches'].join('/'), { localeTokenSearch: params })
      .pipe(
        map(response => response['localeTokenSearch']),
        map((response: LocaleTokenSearch) => {
          this.localeTokenValues$.next(response?.localeTokenValues ?? []);
          return response?.localeTokenValues ?? [];
        })
      );
  }

  getTokens(): LocaleTokenValue[] {
    return this.localeTokenValues$.getValue();
  }

  getTokens$(): Observable<LocaleTokenValue[]> {
    return this.localeTokenValues$.asObservable();
  }

}
